import React from "react";
import SC from "./style";
import Card from "./Card";
import { features, titleFeatures } from "../../../mocData/allInOne";
import TitleCard from "./TitleCard";

function AllProjectTry() {
  return (
    <SC.MainContainer>
      <SC.Container
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <SC.Titlehead
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.2 }}
        >
          {/*  All-in-One Project Management Software */}
          What Prakalpa Does – The AI Brain for Project Execution
        </SC.Titlehead>
        <SC.Subtitle
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.4 }}
        >
          Prakalpa sits across your tools, teams, and workflows — continuously
          analyzing execution signals and delivering intelligence where it
          matters.
        </SC.Subtitle>

        <SC.FeaturesGrid
          initial="hidden"
          animate="visible"
          variants={{
            hidden: { opacity: 0 },
            visible: {
              opacity: 1,
              transition: { staggerChildren: 0.2 },
            },
          }}
        >
          {/* {features.map((feature, index) => (
            <Card key={index} data={feature} index={index} />
          ))} */}
          {titleFeatures.map((feature, index) => (
            <TitleCard key={index} data={feature} index={index} />
          ))}
        </SC.FeaturesGrid>
      </SC.Container>
    </SC.MainContainer>
  );
}

export default AllProjectTry;
